// extracted by mini-css-extract-plugin
module.exports = {"piggyBank":"PiggyBankIcon__piggyBank___2hRht","outline":"PiggyBankIcon__outline___1Mxn_"};